<template>
    <div id="image-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="container">
                <div class="image-holder" v-if="moduleData.Image" :class="moduleData.WatermarkPosition">
                    <b-img-lazy class="shadow-heavy" v-if="moduleData.Image && moduleData.Image.ID" v-bind="imageProps" :src="moduleData.Image.URL" @load.native="imageLoaded = true"
                                :class="{loaded: imageLoaded}"></b-img-lazy>
                    <p v-if="moduleData.Watermark" class="fancy-title">{{moduleData.Watermark}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "ImageElement",
        data() {
            return {
                imageProps: {
                    center: true,
                    fluidGrow: true,
                    blank: true,
                    blankColor: '#fff'
                },
                imageLoaded: false
            }
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        }
    }
</script>
